import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import Typography from 'material-ui/Typography'

const styles = theme => ({
  title: {
    color: '#575757',
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    fontWeight: 500,
    fontSize: '1.2rem',
  },
})

const Title = ({classes, children}) => (
  <Typography variant="title" className={classes.title}>{children}</Typography>
)

Title.propTypes = {
  children: PropTypes.string.isRequired,
}

export default withStyles(styles, {withTheme: true})(Title)



// WEBPACK FOOTER //
// ./src/sections/catalog/components/title.js